import { render, staticRenderFns } from "./PointFinger.vue?vue&type=template&id=29838e64"
import script from "./PointFinger.vue?vue&type=script&lang=js"
export * from "./PointFinger.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports